import React from 'react';
import {useMutation, useQuery} from '@apollo/client';
import gql from 'graphql-tag';
import ReactDocumentTitle from '../../../components/ReactDocumentTitle';
import AppLayout from '../../../layouts/AppLayout';
import BackLink from '../../../ui/BackLink';
import {handleError, handleSuccess} from '../../../utils/Apollo';
import FormTitle from '../../../ui/FormTitle';
import Preloader from '../../../ui/Preloader';
import {EventType} from '../../../schema';
import LicenseTypeForm from '../../../components/licenseType/LicenseTypeForm';
import {reverse} from '../../../urls';
import Menu from '../../../components/licenseType/Menu';
import FormWrapper from '../../../components/licenseType/FormWrapper';

export default function AddScene() {
  const {loading, data, error} = useQuery<FormData>(query, {
    errorPolicy: 'all'
  });

  const [submit] = useMutation(mutation);
  const backLink = reverse('brand_settings_license_types');

  const onFormSubmit = React.useCallback((formData) => {
    submit({
      variables: {data: formData}
    }).then(
      (type) => {
        handleSuccess('License type added', reverse('license_renewal_templates_edit', {licenseTypeId: type.data.createLicenseType.id}))
      },
      (apolloError) => handleError(apolloError)
    );
  }, [submit]);

  return (
    <>
      <ReactDocumentTitle title="Add license type"/>
      <AppLayout className="bg-gray-light">
        <BackLink backLink={backLink} title="Back to settings"/>
        {error && <Preloader/>}
        {loading && <Preloader/>}
        {!!data &&
          <>
            <Menu activeIndex={1}/>
            <FormWrapper>
              <FormTitle>Add license type</FormTitle>
              <LicenseTypeForm onSubmit={onFormSubmit} backLink={backLink} eventTypes={data?.eventTypes}/>
            </FormWrapper>
          </>
        }
      </AppLayout>
    </>
  );
}

interface FormData {
  eventTypes: EventType[]
}


const query = gql`
  query EventTypesFormQuery {
    eventTypes {
      id
      name
    }
  }
`;

const mutation = gql`
  mutation AddFormMutation($data: LicenseTypeInput!) {
    createLicenseType(data: $data) {
      id
      name
      tags
      eventTypes {
        id
        name
      }
    }
  }
`;
